<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <div
            v-if="error"
            class="alert alert-dismissible alert-danger">{{ error }}</div>
          <div
            v-if="deletedItem"
            class="alert alert-dismissible alert-success">{{ deletedItem.subdomain }}.{{ deletedItem.domain.domain }} {{$t('notifications.deleted')}}</div>
        </b-col>
      </b-row>
<!--      <b-row>-->
<!--        <b-col>-->
<!--          <h5>{{$t('views.ticket.list.title')}}</h5>-->
<!--        </b-col>-->
<!--      </b-row>-->
      <b-row>
        <b-col>
          <b-card>
            <template v-if="isLoading">
              <Loader></Loader>
            </template>
            <template v-else>
              <div v-if="items.length > 0">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>{{$t('views.ticket.list.table.date')}}</th>
                        <th>{{$t('views.ticket.list.table.application')}}</th>
                        <th>{{$t('views.ticket.list.table.title')}}</th>
                        <th>{{$t('views.ticket.list.table.description')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in items"
                        :key="item['@id']">
                        <td>
                          {{ $moment(item.createdAt).format('YYYY-MM-DD HH:mm') }}
                        </td>
                        <td>
                          {{ item.application.subdomain }}.{{ item.application.domain.domain }}
                        </td>
                        <td>
                          {{ item.title }}
                        </td>
<!--                        <pre>{{items.case[0]}}</pre>-->
                        <td>
<!--                          <router-link-->
<!--                            v-if="item"-->
<!--                            :to="{name: 'TicketShow', params: { id: item['@id'] }}">-->
<!--                          </router-link>-->
                          {{ item.messageSubstring }}
                        </td>
                        <td>
                          <router-link :to="{name: 'EXCMCaseShow', params: { id: item.case[0]['@id'] }}" v-if="item.case && item.case.length > 0">
                            <button class="btn btn-link fa fa-arrow-right" v-b-tooltip.hover :title="$t('buttons.gotoCase') + ' ' + item.case[0].casetype"></button>
<!--                       //+ String(item.case[0].casetype.title)-->
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
              </div>
              <div v-if="view">
                <pagination
                  :view="view"
                  @getPage="getPage($event)"
                ></pagination>
              </div>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Pagination from '../../Layout/Pagination'
import Loader from '../../Layout/Loader'

export default {
  computed: mapGetters({
    deletedItem: 'ticket/del/deleted',
    error: 'ticket/list/error',
    items: 'ticket/list/items',
    isLoading: 'ticket/list/isLoading',
    view: 'ticket/list/view'
  }),
  components: {
    Pagination,
    Loader
  },
  created () {
    this.getPage()
  },

  methods: {
    ...mapActions({
      getPage: 'ticket/list/default'
    })
  }
}
</script>
